"use client";
import { useEffect, useState } from "react";
import SectionTitle from "../Common/SectionTitle";
import SingleBenefitsSection from "./SingleBenefitsSection";
import useBenefits from "./benefitsData"; // ✅ renamed import

interface BenefitsProps {
  benefitsToShow?: number[];
}

const Benefits: React.FC<BenefitsProps> = ({ benefitsToShow }) => {
  const benefitsData = useBenefits(); // ✅ call the function to get translated array
  let filteredBenefits = benefitsData;

  if (benefitsToShow && benefitsToShow.length > 0) {
    // Only show cards whose id is in benefitsToShow
    filteredBenefits = benefitsData.filter((b) => benefitsToShow.includes(b.id));
  } else {
    filteredBenefits = []; // Show nothing if no ids specified
  }

  // Avoid hydration mismatch
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <section id="features" className="section-padding bg-warm-50 pt-20">
      <div className="container mx-auto px-4 ">
        <SingleBenefitsSection benefits={filteredBenefits} />
      </div>
    </section>
  );
};

export default Benefits;
